import React, { useState } from 'react';

const Filters = ({ filters, onFilterChange, onReset }) => {
    const [localFilters, setLocalFilters] = useState(filters || {});

    const handleFilterChange = (key, value) => {
        const updatedFilters = { ...localFilters, [key]: value };
        setLocalFilters(updatedFilters);
        onFilterChange(updatedFilters);
    };

    const handleReset = () => {
        const resetFilters = {};
        Object.keys(localFilters).forEach(key => {
            resetFilters[key] = '';
        });
        setLocalFilters(resetFilters);
        onReset(resetFilters);
    };

    const renderFilterInput = (filter) => {
        const { key, label, type, options, placeholder } = filter;
        const value = localFilters[key] || '';

        switch (type) {
            case 'select':
                return (
                    <div key={key} className="mb-3">
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                            {label}
                        </label>
                        <select
                            value={value}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                            className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="">All</option>
                            {options?.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                );

            case 'date':
                return (
                    <div key={key} className="mb-3">
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                            {label}
                        </label>
                        <input
                            type="date"
                            value={value}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                            className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder={placeholder}
                        />
                    </div>
                );

            case 'number':
                return (
                    <div key={key} className="mb-3">
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                            {label}
                        </label>
                        <input
                            type="number"
                            value={value}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                            className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder={placeholder}
                            step={filter.step || '1'}
                            min={filter.min}
                            max={filter.max}
                        />
                    </div>
                );

            case 'text':
            default:
                return (
                    <div key={key} className="mb-3">
                        <label className="block mb-1 text-sm font-medium text-gray-700">
                            {label}
                        </label>
                        <input
                            type="text"
                            value={value}
                            onChange={(e) => handleFilterChange(key, e.target.value)}
                            className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder={placeholder || `Enter ${label.toLowerCase()}`}
                        />
                    </div>
                );
        }
    };

    if (!filters || filters.length === 0) {
        return null;
    }

    return (
        <div className="bg-white p-4 rounded-lg shadow-md mb-6">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-gray-800">Filters</h3>
                <button
                    onClick={handleReset}
                    className="text-sm text-blue-600 hover:text-blue-800 font-medium"
                >
                    Reset Filters
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {filters.map((filter) => renderFilterInput(filter))}
            </div>
        </div>
    );
};

export default Filters;

